import axios from '../../axios/index.js'

export default{
    rows(id,year){
        return axios.get('gantt/'+id+'/'+year)
    },
    rowsHistorial(id,year,month){
        return axios.get('gantt_historial/'+id+'/'+year+'/'+month)
    },
    clients(){
        return axios.get('gantt/clients')
    },
    historialSelect(){
        return axios.get('gantt_historial/select')
    },
}